import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";
import { axInst } from "./Service";
import axios from "axios";
import Swal from "sweetalert2";
import Loader from "../Loader/Loder";

function Login() {
  const navigate = useNavigate();
  const { keycloak, initialized } = useKeycloak();
  const [loading, setLoading] = useState(false);

  // useEffect(() => {
  //   if (initialized && keycloak.authenticated) {
  //     const { preferred_username } = keycloak.tokenParsed;
  //     handleLogin(keycloak.token, preferred_username);
  //   }
  // }, [initialized, keycloak]);

  // for Dev

  // const handleLogin = async (token, username) => {
  //   setLoading(true);

  //   // Input validation
  //   if (!token || typeof token !== "string") {
  //     console.error("Invalid token received");
  //     return;
  //   }
  //   if (!username || typeof username !== "string") {
  //     console.error("Invalid username received");
  //     return;
  //   }

  //   const basicAuth =
  //     "Basic " +
  //     btoa(`${process.env.REACT_APP_UNAME}:${process.env.REACT_APP_PWD}`);

  //   try {
  //     const res = await axios.post(
  //       `${
  //         process.env.REACT_APP_API_URL
  //       }retails/token?key_clock_token=${encodeURIComponent(token)}`,
  //       {},
  //       {
  //         headers: { Authorization: basicAuth },
  //         withCredentials: true, // HttpOnly cookie
  //       }
  //     );

  //     // DO NOT store token anywhere client-side
  //     if (res.data.Token) {
  //       // Log login event
  //       await axInst.post(
  //         `${process.env.REACT_APP_API_URL}user-system-logs`,
  //         {},
  //         { withCredentials: true }
  //       );

  //       // Fetch profile via secure cookie
  //       const profileRes = await axInst.get(
  //         `${process.env.REACT_APP_API_URL}user-profile`,
  //         { withCredentials: true }
  //       );

  //       // ✅ Store ONLY non-sensitive UI values in sessionStorage
  //       sessionStorage.setItem("username", username.toUpperCase());

  //       if (profileRes.data?.PRIMARY_POSITION_TYPE) {
  //         sessionStorage.setItem(
  //           "userType",
  //           profileRes.data.PRIMARY_POSITION_TYPE
  //         );
  //       }

  //       navigate("/home");
  //     } else {
  //       handleLogout(username);
  //     }
  //   } catch (error) {
  //     console.log(error);

  //     const msg = error?.response?.data?.message;

  //     if (msg === "Token Already Used") {
  //       sessionStorage.clear();
  //       keycloak.logout({ redirectUri: window.location.origin });
  //     } else if (msg === "user_id does not exist") {
  //       Swal.fire({
  //         icon: "error",
  //         title: "User ID Not Found",
  //         text: "Your user ID does not exist in our system. You will be logged out in 5 seconds.",
  //         timer: 5000,
  //         showConfirmButton: false,
  //         allowOutsideClick: false,
  //       }).then(() => {
  //         sessionStorage.clear();
  //         keycloak.logout({ redirectUri: window.location.origin });
  //       });
  //     }
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // for Localhost

  useEffect(() => {
    if (!initialized) return;

    // 👇 If user is NOT logged in, trigger Keycloak login flow
    if (!keycloak.authenticated) {
      keycloak.login(); // this will open the Keycloak login page

      return;
    }
    const { preferred_username } = keycloak.tokenParsed;
    handleLogin(keycloak.token, preferred_username);
  });

  const handleLogin = async (token, username) => {
    setLoading(true);
    const basicAuth =
      "Basic " +
      btoa(`${process.env.REACT_APP_UNAME}:${process.env.REACT_APP_PWD}`);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}retails/token?key_clock_token=${token}`,
        {},
        {
          headers: {
            Authorization: basicAuth,
          },
        }
      );
      if (res.data.Token) {
        localStorage.setItem("token", res.data.Token);
        localStorage.setItem("username", `${username.toUpperCase()}`);
        await axInst.post(`${process.env.REACT_APP_API_URL}user-system-logs`);
        const profileRes = await axInst.get(
          `${process.env.REACT_APP_API_URL}user-profile`
        );
        if (profileRes.data) {
          localStorage.setItem(
            "userType",
            profileRes.data.PRIMARY_POSITION_TYPE
          );
        }

        navigate("/home");
      } else {
        handleLogout(username);
      }
    } catch (error) {
      console.log(error);

      const msg = error?.response?.data?.message;

      if (msg === "Token Already Used") {
        localStorage.clear();
        keycloak.logout({ redirectUri: window.location.origin });
      } else if (msg === "user_id does not exist") {
        Swal.fire({
          icon: "error",
          title: "User ID Not Found",
          text: "Your user ID does not exist in our system. You will be logged out in 5 seconds.",
          timer: 5000,
          showConfirmButton: false,
          allowOutsideClick: false,
        }).then(() => {
          localStorage.clear();
          keycloak.logout({ redirectUri: window.location.origin });
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async (username) => {
    Swal.fire({
      title: "Your previous session is still active.",
      text: "Please logout first and re-login!",
      icon: "warning",
      showCancelButton: false,
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Logout",
      allowOutsideClick: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const basicAuth =
            "Basic " +
            btoa(`${process.env.REACT_APP_UNAME}:${process.env.REACT_APP_PWD}`);

          await axios.post(
            `${
              process.env.REACT_APP_API_URL
            }logout?user_id=${username.toUpperCase()}`,
            {},
            {
              headers: { Authorization: basicAuth },
            }
          );

          sessionStorage.clear();
          keycloak.logout({ redirectUri: window.location.origin });
        } catch (error) {
          console.log(error);
        }
      }
    });
  };

  // const fetchDashboards = async () => {
  //   const { data } = await axInst.post(
  //     `${process.env.REACT_APP_API_URL}dashboard`,
  //     {},
  //     { withCredentials: true }
  //   );
  //   return data.map((item) => item[1]);
  // };

  return (
    <div>{loading ? <Loader /> : <div>{/* Render other content */}</div>}</div>
  );
}

export default Login;
